import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type SOCDashboard } from '../../api/security';

export function InvestigationConsolePage() {
  const [soc, setSoc] = useState<SOCDashboard | null>(null);
  useEffect(() => { void securityApi.soc().then(setSoc); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Investigation Console</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div>
          <h2 className="font-medium">Security Timeline</h2>
          <ul className="mt-3 space-y-2">{soc?.security_timeline.map((a) => (
            <li key={a.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{a.action}: {a.message}</li>
          ))}</ul>
        </div>
        <div>
          <h2 className="font-medium">Threat Rules</h2>
          <ul className="mt-3 space-y-2">{soc?.threat_rules.map((r) => (
            <li key={r.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{r.name} ({r.category}) {r.enabled ? '✓' : '✗'}</li>
          ))}</ul>
        </div>
      </div>
    </div>
  );
}
